import { css, unsafeCSS } from 'lit';
import {sbkCoreBreakpointMd, sbkCoreBreakpointXl} from '@/tokens/variables.js'

const breakpointMd = unsafeCSS(`${sbkCoreBreakpointMd}`);
const breakpointXl = unsafeCSS(`${sbkCoreBreakpointXl}`);

export const facet6 = css`
  :host {
  }

    
  .image__facet-6 {
    ::slotted(img), ::slotted(picture) {
      object-fit: cover;
      clip-path: polygon( 16.875% 21.3%,50.05% 2.175%,91.425% 26.1%,91.425% 64.375%,91.425% 64.375%,91.332% 66.137%,91.056% 67.859%,90.606% 69.53%,89.988% 71.136%,89.209% 72.666%,88.277% 74.106%,87.198% 75.444%,85.979% 76.669%,84.627% 77.766%,83.15% 78.725%,50% 97.825%,8.575% 73.925%,8.575% 35.675%,8.575% 35.675%,8.668% 33.906%,8.944% 32.178%,9.394% 30.504%,10.013% 28.894%,10.794% 27.363%,11.729% 25.921%,12.811% 24.581%,14.034% 23.357%,15.391% 22.259%,16.875% 21.3% );
      aspect-ratio: 1;
      width: 100%;
        height: auto;
      z-index: 2;
    }
  }

  .image-shapes-6 {
    position: absolute;
      top: 2.2%;
      left: -8.5%;
      width: 119%;
    height: auto;
    z-index: 3;
  }

  .image-shapes-6--xl {
    display: none;
  }

    .image-shapes-6--crop-mobile {
        display: none;
    }

  @media screen and (min-width: ${breakpointXl}) {
    .image-shapes-6--xl {
      display: block;
      position: absolute;
        top: 1.2%;
        left: -12.3%;
        width: 107.3%;
      height: auto;
      z-index: 3;
    }
    .image-shapes-6 {
        display: none;
    }
      .image__facet-6--alternative .image-shapes-6--xl {
          top: 0.5%;
          left: 1.3%;
          width: 108%;
      }
  }

    .image__facet-6--crop-mobile {
        ::slotted(img), ::slotted(picture) {
            aspect-ratio:  4 / 3;
            clip-path: polygon( 0% 0%,0% 61.244%,50.008% 99.704%,90.175% 68.796%,90.175% 68.796%,91.919% 67.27%,93.517% 65.526%,94.961% 63.584%,96.241% 61.465%,97.348% 59.187%,98.274% 56.77%,99.01% 54.234%,99.546% 51.598%,99.875% 48.883%,99.986% 46.107%,99.986% 0%,0% 0% );
        }
        .image-shapes-6, .image-shapes-6--xl {
            display: none;
        }
        .image-shapes-6--crop-mobile {
            display: block;
        }
        @media screen and (min-width: ${breakpointMd}) {
            ::slotted(img), ::slotted(picture) {
                aspect-ratio: 1;
                clip-path: polygon( 16.875% 21.3%,50.05% 2.175%,91.425% 26.1%,91.425% 64.375%,91.425% 64.375%,91.332% 66.137%,91.056% 67.859%,90.606% 69.53%,89.988% 71.136%,89.209% 72.666%,88.277% 74.106%,87.198% 75.444%,85.979% 76.669%,84.627% 77.766%,83.15% 78.725%,50% 97.825%,8.575% 73.925%,8.575% 35.675%,8.575% 35.675%,8.668% 33.906%,8.944% 32.178%,9.394% 30.504%,10.013% 28.894%,10.794% 27.363%,11.729% 25.921%,12.811% 24.581%,14.034% 23.357%,15.391% 22.259%,16.875% 21.3% );
            }
            .image-shapes-6 {
                display: block;
            }
            .image-shapes-6--crop-mobile {
                display: none;
            }
        }
    }

    .image-shapes-6--crop-mobile {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: auto;
        z-index: 1;
    }
`;